<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">Private Sales</h2>
            </div>

            <div class="tab-wrap">
                <v-tabs :value="tab" grow show-arrows center-active class="tab tab--underline">
                    <v-tab v-for="{ value, text } in tabs" :key="value" :to="`/private-sales/${value}`">
                        <span>{{ text }}</span>
                    </v-tab>
                </v-tabs>
            </div>

            <v-tabs-items :value="tab" touchless>
                <!-- S: 작품목록 -->
                <private-sales-list />
                <!-- E: 작품목록 -->
                <!-- S: Private Sales이란? -->
                <private-sales-about />
                <!-- E: Private Sales이란? -->
                <!-- S: Private Sales의 좋은점 -->
                <private-sales-merit />
                <!-- E: Private Sales의 좋은점 -->
                <!-- S: KATA 옥션의 강점 -->
                <private-sales-kata />
                <!-- E: KATA 옥션의 강점 -->
                <!-- S: 장르와 전제조건 -->
                <private-sales-genre />
                <!-- E: 장르와 전제조건 -->
            </v-tabs-items>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import PrivateSalesList from "@/components/client/private/private-sales-list.vue";
import PrivateSalesAbout from "@/components/client/private/private-sales-about.vue";
import PrivateSalesMerit from "@/components/client/private/private-sales-merit.vue";
import PrivateSalesKata from "@/components/client/private/private-sales-kata.vue";
import PrivateSalesGenre from "@/components/client/private/private-sales-genre.vue";
import { PRIVATE_SALES_TABS } from "@/assets/variables";
const tabs = Object.values(PRIVATE_SALES_TABS);

export default {
    components: {
        ClientPage,
        PrivateSalesList,
        PrivateSalesAbout,
        PrivateSalesMerit,
        PrivateSalesKata,
        PrivateSalesGenre,
    },
    props: {
        tab: { type: String, default: PRIVATE_SALES_TABS.LIST.value },
    },
    data() {
        return {
            tabs,
        };
    },
    mounted() {
        this.syncPath();
    },
    methods: {
        syncPath() {
            const path = `/private-sales/${this.tab}`;
            if (!this.$route.path.includes(path)) this.$router.replace(path);
        },
    },
};
</script>
